import React, { useEffect, useState } from "react";
import { Box } from "../design-system";
import Modal from "../design-system/Modal";
import AccountTabNav, { AccountTab } from "./AccountTabNav";
import ProfileTab from "./ProfileTab";
import SubscriptionTab from "./SubscriptionTab";
import UsageTab from "./UsageTab";
import AutoTab from "./AutoTab";
import ModalHeader from "./components/ModalHeader";

const MODAL_PADDING = "32px";

interface AccountSettingsModalProps {
  open: boolean;
  onClose: () => void;
  /** Open on this tab (e.g. Auto, from the library's side list). */
  initialTab?: AccountTab;
}

const tabContent: Record<AccountTab, React.ReactElement> = {
  [AccountTab.Profile]: <ProfileTab/>,
  [AccountTab.Subscription]: <SubscriptionTab />,
  [AccountTab.Usage]: <UsageTab />,
  [AccountTab.Auto]: <AutoTab />,
};

const AccountSettingsModal = ({ open, onClose, initialTab }: AccountSettingsModalProps) => {
  const [activeTab, setActiveTab] = useState<AccountTab>(initialTab ?? AccountTab.Profile);
  useEffect(() => { if (open) setActiveTab(initialTab ?? AccountTab.Profile); }, [open, initialTab]);

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
          padding: MODAL_PADDING,
          gap: "35px",
        }}
      >
        <ModalHeader onClose={onClose} />

        <AccountTabNav activeTab={activeTab} onTabChange={setActiveTab} />

        <Box
          role="tabpanel"
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            overflow: "auto",
          }}
        >
          {tabContent[activeTab]}
        </Box>
      </Box>
    </Modal>
  );
};

export default AccountSettingsModal;
